import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, OnDestroy} from '@angular/core';
import {MapService} from '../../shared/map/map.service';
import {LinkingService} from '../linking.service';
import {Linking} from '../linking.model';
import {MappingService} from '../mapping.service';
import {IMappingDefinitions, IMappingDetails} from '../mapping';

import {convertFeatureToMapObject} from '../../shared/utils';
import {BaseComponent} from '../../components/general/base/base.component';
import {Observable, Subject} from 'rxjs';
import {debounceTime, map, takeUntil, distinctUntilChanged} from 'rxjs/operators';
import { ILayer } from '../../shared/map/layer/layer.type';
import { AuthService } from '~app/auth/auth.service';
import { MapObject } from '../../shared/map/types';

@Component({
  selector: 'qm-linking-misonet',
  templateUrl: './linking-misonet.component.html',
  styleUrls: ['./linking-misonet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkingMisonetComponent extends BaseComponent<Linking> implements OnInit, OnDestroy {
  public mappingDataMisoNet: IMappingDefinitions = {};
  public mappingDataMisoNetList: IMappingDetails[] = [];

  public editLink: string;
  public currentLink: MapObject = null;
  public mapObjectList: MapObject[] = [];
  public linkingListMisoNet: Linking[] = [];
  public selectedLayer: string;
  public layers: ILayer[];
  public regoId: string;
  public loading: boolean;
  /**
   * Paging
   */
  public page: number = 1;
  public pageSize: number = 20;
  public total: number = 0;

  private readonly ngUnsubscribe: Subject<void> = new Subject();

  public search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        if (!term) {
          return [];
        }
        term = term.toLowerCase();
        return this.mapObjectList.filter(obj => obj.title && obj.title.toLowerCase().includes(term)).slice(0, 10);
      })
    )

    public searchSource = (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map(term => {
          if (!term) {
            this.mappingDataMisoNetList = this.mappingDataMisoNet.sourceSystemList;
          }
          term = term.toLowerCase();
          this.mappingDataMisoNetList =
            this.mappingDataMisoNet.sourceSystemList.filter(obj => obj.deviceId && obj.deviceId.toLowerCase().includes(term));
          this.total = this.mappingDataMisoNetList.length;
          this.page = 1;
          this.changeDetectorRef.markForCheck();
      })
    )

   constructor(
      private readonly linkingService: LinkingService,
      private readonly mappingService: MappingService,
      private readonly mapService: MapService,
      private readonly authService: AuthService,
      private readonly changeDetectorRef: ChangeDetectorRef) {
    super();
    this.name = 'LinkingMisonetComponent';
  }

  ngOnInit() {
    this.loadList();
    this.layers = this.mapService.getLayerList();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private async loadList() {
    this.linkingListMisoNet = [];
    this.loading = true;

    //// LINKING LIST FROM RB
    const list = await this.linkingService.filter({sourceSystem: 'misonet'});
    if (list.isOk) {
      for (const row of list.data) {
        this.linkingListMisoNet[row.sourceId] = row;
      }
    }

    //// mapping list from RB
    this.mappingDataMisoNet = await this.mappingService.getMisoNetMappingList();
    this.mappingDataMisoNetList = this.mappingDataMisoNet.sourceSystemList;
    this.total = this.mappingDataMisoNetList.length;
    this.mapService.visibleMarkers$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(markers => {
      this.mapObjectList = Array.from(this.mapService.getLayerFeatures()).flatMap(([layerName, features]) => {
        return features.map(feature => convertFeatureToMapObject(feature));
      });
      this.mapObjectList = this.mapObjectList.concat(markers.map(marker => {
        const l = marker.layer.metadata;
        return {id: marker.properties[l.uniqueBy], title: marker.properties[l.labelBy], layerId: marker.layer.id} as MapObject;
      }));
      this.loading = false;
      this.changeDetectorRef.markForCheck();
    });
  }

  public setEditLink(asset: string) {
    this.editLink = asset;
    this.currentLink = null;
  }

  public async saveLink() {
    if (this.regoId || this.currentLink) {
      const m = new Linking();
      if (this.regoId) {
        m.regoId = this.regoId;
      } else {
        m.regoId = this.currentLink.id;
      }
      m.sourceId = this.editLink;
      m.sourceSystem = this.mappingDataMisoNet.sourceSystem;
      this.linkingListMisoNet[this.editLink] = m;
      await this.linkingService.create(m);
      this.currentLink = null;
      this.editLink = '';
      this.loadList();
    }
  }

  public getMapObjectTitle(obj: MapObject): string {
    return obj.title;
  }

  public getTitle(id: string): string {
    const r = this.mapObjectList.find(o => {
      return `${o.id}` === `${id}`;
    });
    return r ? r.title : id;
  }

  public async unLink() {
    const link = this.linkingListMisoNet[this.editLink];
    await this.linkingService.remove(link);
    this.editLink = '';
    this.loadList();
  }
}
